"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchImageFileByUrl = void 0;
const fetchImageFileByUrl = (imageUrl, contentType = 'image/jpeg', imageName = 'imagem') => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const data = yield fetch(imageUrl, {
            method: 'GET',
            headers: {
                'Content-Type': contentType,
                'Access-Control-Allow-Origin': '*',
                Accept: 'image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8',
            },
        });
        const imageBlob = yield data.blob();
        const extension = imageUrl.substring(imageUrl.lastIndexOf('.') + 1);
        return new File([imageBlob], `${imageName}.${extension}`, { type: contentType });
    }
    catch (e) {
        throw new Error(`Cannot fetch image file. Reason: ${e}`);
    }
});
exports.fetchImageFileByUrl = fetchImageFileByUrl;
